// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"aa35bfdf","79":"87e3a754","319":"c49618eb","433":"fd95a753","438":"e4ef7c05","979":"1db5f9df","991":"56d7d91a"}[chunkId] + ".chunk.js";
};